import { render, staticRenderFns } from "./FundsReport.vue?vue&type=template&id=6bddef9a&scoped=true"
import script from "./FundsReport.vue?vue&type=script&lang=js"
export * from "./FundsReport.vue?vue&type=script&lang=js"
import style0 from "./FundsReport.vue?vue&type=style&index=0&id=6bddef9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bddef9a",
  null
  
)

export default component.exports